// extracted by mini-css-extract-plugin
module.exports = {"pause":"Pause_pause__xkUGB"};